import React, { Component, Fragment } from 'react';
import { Link, View, TextArea, ActionSheet, isWeb, Text, Vibration, FilePicker, I18nManager, Camera, isIphoneX, isAndroid } from 'core';
import { Keyboard } from 'react-native';
import { lang } from 'lang';
import { theme, isMVP } from 'constants';
import * as actions from 'actions';
import { IcoComposeActions, IcoSend, IcoVoiceNote, IcoCamera, IcoGallery, IcoDoc, IcoPolls, IcoLocation, IcoAccount, IcoCancel, IcoDone } from 'icons';
import { textTemplate, uploadTemplate, imageProcessor } from 'utils';
import { onMediaAdded } from './compose_type';

class Compose extends Component {
  timeout_id;
  state = {
    message: '',
    is_recording: false
  };

  typingIndicator = () => {
    const { conv_id } = this.props;
    // if conv is tmp_PM dont show typing indicator
    if (this.props.tmp_pm) {
      return;
    }
    // Setting Typing Indicator
    !this.timeout_id && actions.sendSetTypingIndicator({ conv_id });
    // unsetting Typing Indicator
    clearTimeout(this.timeout_id);
    this.timeout_id = setTimeout(() => {
      this.timeout_id = 0;
      actions.sendUnsetTypingIndicator({ conv_id });
    }, 4000);
  };

  componentDidMount() {
    this.keyboardDidShowListener = Keyboard.addListener('keyboardWillShow', () => this.setState({ input_focused: true }));
    this.keyboardDidHideListener = Keyboard.addListener('keyboardWillHide', () => this.setState({ input_focused: false }));
  }
  componentWillUnmount() {
    this.keyboardDidShowListener.remove();
    this.keyboardDidHideListener.remove();
  }

  _sendMessage = () => {
    const { conv_id, tmp_pm } = this.props;
    const { message } = this.state;
    this.setState({ message: '' });
    const msgs = [textTemplate({ text: message })];
    actions.sendMessage({ msgs, conv_id, tmp_pm });
    if (this.props.tmp_pm) {
      return;
    }
    clearTimeout(this.timeout_id);
    actions.sendUnsetTypingIndicator({ conv_id });
  };
  _sendThumbsup = () => {
    const { conv_id, tmp_pm } = this.props;
    const msgs = [textTemplate({ text: '👍' })];
    actions.sendMessage({ msgs, conv_id, tmp_pm });
  };
  _prepareOptions = () => {
    const { conv_id } = this.props;
    let options = [
      {
        text: isWeb ? lang.PHOTOS_VIDEOS : lang.PHOTOS,
        onPress: () => FilePicker.show({ asset_type: FilePicker.TYPES.MEDIA, multiple: true, only_uri: true }, this._uploadMedia, conv_id),
        icon: IcoGallery
      }
    ];
    options = !isWeb
      ? [
          ...options,
          {
            text: lang.CAMERA,
            onPress: () => FilePicker.show({ asset_type: FilePicker.TYPES.CAMERA, multiple: false, only_uri: true }, this._uploadMedia, conv_id),
            icon: IcoCamera
          },
          { text: lang.LOCATION, onPress: () => actions.clickShareLocation(), icon: IcoLocation },
          {
            text: lang.CONTACT,
            onPress: () => actions.clickShareContact(),
            icon: IcoAccount
          }
        ]
      : options;
    !isMVP && (options = options.concat([{ text: lang.DOCUMENTS, onPress: () => {}, icon: IcoDoc }, { text: lang.POLL, onPress: () => {}, icon: IcoPolls }]));
    return options;
  };

  _uploadMedia = files => onMediaAdded(files, this.props);

  render() {
    const { is_online } = this.props;
    const { message, is_recording, input_focused } = this.state;
    const trimed_msg = this.state.message.trim();
    let options = this._prepareOptions();
    const isRTL = I18nManager.isRTL;
    return (
      <View style={[styles.holder, isRTL && { flexDirection: 'row-reverse' }, isIphoneX && !input_focused && { paddingBottom: 20 }]}>
        <ActionBtn is_online={is_online} options={options} />
        <View style={{ flex: 1 }}>
          <TextArea
            style={styles.input}
            value={message}
            returnKeyType="none"
            onReturn={trimed_msg && this._sendMessage}
            onChangeText={message => {
              this.setState({ message, last_type: Date.now() });
              this.typingIndicator();
            }}
          />
        </View>
        {trimed_msg ? (
          <Send is_online={is_online} send={this._sendMessage} />
        ) : (
          <Link title="👍" size={isAndroid?18:26} disabled={!is_online} style={styles.right_btn} content_style={styles.thumbsup} onPress={this._sendThumbsup} />
        )}
      </View>
    );
  }
}
const Send = ({ is_online, send }) => (
  <Link
    disabled={!is_online}
    icon={IcoSend}
    size={7}
    color="white"
    selected_color="white"
    style={styles.right_btn}
    content_style={styles.sendbtn}
    icon_style={{ marginLeft: 2 }}
    onPress={send}
  />
);
const ActionBtn = ({ is_online, options }) => (
  <Link
    disabled={!is_online}
    icon={IcoComposeActions}
    style={styles.left_btn}
    icon_style={{ color: theme.primary_color }}
    size={10}
    keyboardDismiss
    onPress={event => {
      ActionSheet.show({
        event,
        options
      });
    }}
  />
);
const VoiceNote = ({ is_online, is_recording, onPress, onCancel }) =>
  is_recording ? (
    <View style={styles.record_bar}>
      <Link size={30} icon={IcoCancel} onPress={onCancel} color={theme.error_color} />
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        <IcoVoiceNote selected size={25} color={theme.error_color} />
        <Text>00:01</Text>
      </View>
      <Link size={30} icon={IcoDone} onPress={onCancel} color={theme.success_color} />
    </View>
  ) : (
    <View>
      <Link disabled={!is_online} icon={IcoVoiceNote} size={24} style={styles.right_btn} color={theme.primary_color} onPress={onPress} />
    </View>
  );
const styles = {
  holder: {
    flexDirection: 'row',
    borderColor: theme.gray_color_lighten(0.2),
    backgroundColor: theme.gray_color_lighten(0.02),
    borderTopWidth: theme.hairline,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 44,
    paddingHorizontal: 5
  },
  input: {
    marginTop: 5,
    marginBottom: 5,
    borderColor: theme.gray_color_lighten(0.3),
    borderWidth: theme.hairline,
    borderRadius: 16
  },
  sendbtn: {
    backgroundColor: theme.primary_color,
    borderRadius: 16,
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center'
  },
  thumbsup: {
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 3
  },
  left_btn: {
    paddingRight: 5,
    paddingLeft: 5,
    height: 43,
    width: 47,
    justifyContent: 'center',
    alignItems: 'center'
  },
  right_btn: {
    paddingRight: 5,
    paddingLeft: 5,
    height: 43,
    justifyContent: 'center',
    alignItems: 'center'
  },
  record_bar: {
    flex: 1,
    //backgroundColor: 'red',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center'
  }
};
export default Compose;



// WEBPACK FOOTER //
// ./src/components/middle/chat/compose.js